export function updateActionErrors (action, error) {
  return {
    ...action,
    errors: error
  };
}
